var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdpFreeShipping({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M15.2 30.1v-17M29.3 14.1V8c0-.6-.3-1-.8-1.3L15.7 1.1h-1L1.7 6.6c-.5.2-.8.7-.8 1.3V23c0 .5.3 1 .8 1.2L14.6 30h1.1l12.8-5.6c.5-.2.8-.7.8-1.2V21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7l13.6 5.9h1.1l13.6-6M22 3.8L8 9.9",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9 19.4h-1v-2.8h-.5v-.9h.4v-1.1c0-.4.1-.8.4-1.1.3-.3.6-.5 1-.5l.6.1v1a1 1 0 00-.5-.2c-.2 0-.3.1-.4.3v1.5h.9v1h-1v2.7zM23.8 15.7v.6c.1-.4.5-.7 1-.7h.4v1a.9.9 0 00-.5 0c-.3 0-.5 0-.7.2-.2.2-.3.5-.2.8v1.8h-1v-3.7h1zM26.6 17.7c0 .6.3 1 .9 1 .3 0 .7-.2.9-.5l.9.1c-.3.8-1 1.2-1.8 1.2a1.8 1.8 0 01-2-2 1.8 1.8 0 012-1.9 1.8 1.8 0 011.9 2v.1h-2.8zm1.8-.6c-.1-.5-.5-.8-1-.7-.3 0-.7.2-.8.7h1.8zM31 17.7c0 .6.3 1 .8 1 .4 0 .7-.2.9-.5l1 .1c-.3.8-1 1.2-1.8 1.2a2 2 0 010-3.9 1.8 1.8 0 011.8 2v.1H31zm1.7-.6a.9.9 0 00-1.7 0h1.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdpFreeShipping);
export default __webpack_public_path__ + "static/media/pdp-free-shipping.423f6276f524501f01273c2850462f3e.svg";
export { ForwardRef as ReactComponent };